import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Crib = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M29 6C28.448 6 28 6.448 28 7V8H4V7C4 6.448 3.552 6 3 6C2.448 6 2 6.448 2 7V17C2 19.757 4.243 22 7 22H8V23C8 23.551 7.551 24 7 24H5C4.448 24 4 24.448 4 25C4 25.552 4.448 26 5 26H7C8.654 26 10 24.654 10 23V22H22V23C22 24.654 23.346 26 25 26H27C27.552 26 28 25.552 28 25C28 24.448 27.552 24 27 24H25C24.449 24 24 23.551 24 23V22H25C27.757 22 30 19.757 30 17V7C30 6.448 29.552 6 29 6ZM7 20C5.346 20 4 18.654 4 17V10H8V20H7ZM10 10H15.125V20H10V10ZM17.125 20V10H22V20H17.125ZM25 20H24V10H28V17C28 18.654 26.654 20 25 20Z" />
	</svg>
);

export default Crib;
